export default "__VITE_ASSET__BkDG8qeB__"